import React from "react";

const CommentaryByOver = ({ data, selectedInnings }) => {

  const filtered = data?.filter((item) => item?.inor === selectedInnings);

  const grouped = filtered?.reduce((acc, item) => {
    const over = Math.floor(item?.ovr);
    if (!acc[over]) acc[over] = [];
    acc[over]?.push(item);
    return acc;
  }, {});

  const sortedOvers = Object.keys(grouped)
    .sort((a, b) => b - a)
    ?.map((key) => ({
      over: key,
      deliveries: grouped[key]?.sort((a, b) => b?.ovr - a?.ovr),
    }));
  return (
    <div className="commentary-container">
      {sortedOvers?.map(({ over, deliveries }) => {
        const firstWithBowler = deliveries.find((d) => d?.player?.name);
        const bowler = firstWithBowler?.player?.name ?? "";
        const runs = deliveries.reduce((sum, d) => sum + d?.sc, 0);
        const wickets = deliveries.filter((d) => d?.dsc === "W").length;

        return (
          <div className="over-block" key={over}>
            <div className="over-header">
              <strong>Over {Number(over) + 1}</strong>
              <span className="bowler-stats">
                {bowler} {runs} Runs, {wickets} Wickets
              </span>
            </div>

            <ul className="over-commentary-list">
              {deliveries?.map((ball) => (
                <li className={`comment `} key={ball?.id}>
                  <div className="left_inner">
                    {ball?.dsc !== "I" ? (
                      <div className="ball-label">
                        <span
                          className={`ball-dsc ${ball?.dsc === "W" ? "wicket" : ball?.dsc === "4" || ball?.dsc === "6" ? "boundary" : ""}`}
                        >
                          {ball?.dsc}{" "}
                        </span>
                        <span className="ball-ovr">{ball?.ovr}</span>
                      </div>
                    ) : (
                      <i className="head_ico ico_Vector1"></i>
                    )}
                  </div>
                  <div className="comment-body">
                    {ball?.player?.name && ball?.batsman?.name && (
                      <strong>
                        {ball?.player?.name} to {ball?.batsman?.name}
                      </strong>
                    )}
                    <p>{ball?.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default CommentaryByOver;
